
import React,{useMemo,useState,useEffect} from 'react';
import MaterialReactTable from 'material-react-table';
import swal from "sweetalert";
import { fetchData, postData,postFormData } from '../../../../redux/apiSlice';
import AuthUser from '../../../../Components/Auth/AuthUser';
import {Box,Button,Grid,Dialog ,DialogActions,DialogTitle,Typography,DialogContent,FormControl,InputLabel,Select,MenuItem,
    OutlinedInput,InputAdornment,IconButton,Tooltip,FormHelperText,FormLabel,useMediaQuery,TextField,Card,CardContent} from '@mui/material';
import {  useDispatch } from 'react-redux';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { ExportToCsv } from 'export-to-csv';
import {  useNavigate,useParams} from 'react-router-dom';
import Moment from 'moment';
import { Form, Formik } from 'formik';
import { TextareaAutosize } from '@mui/base';
import * as Yup from 'yup';
import ActivityLog from '../Components/ActivityLog';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import CloseIcon from "@mui/icons-material/Close";
import { CardOverflow } from '@mui/joy';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

function AvailedService({companyId,handleFreezStart,handleFreezStop}) {
    const dispatch = useDispatch();
    const {http,user} = AuthUser();
    const navigate = useNavigate();
    const [rowSelection, setRowSelection] = useState({});
    const rowsSeleted = Object.keys(rowSelection);
    const [data, setData] = useState([]);
    const [columnVisibility, setColumnVisibility] = React.useState({});
    const isMobile = useMediaQuery('(max-width:600px)');
    const [freez, setFreez] = React.useState(false);
    const [open, setOpen] = React.useState(false);
    const [fullWidth, setFullWidth] = React.useState(true);
    const [maxWidth, setMaxWidth] = React.useState('md');
    const [mediaType, setMediaype] = useState();
    const [fileError, setFileError] = useState('');
    const [activityType, setActivityType] = useState('');
    const [assetLink, setAssetLink] = useState('');
    const [activityLog, setActivityLog] = useState([]);
    const [activeSection, setActiveSection] = useState('services');
    const fileInputRef = React.useRef(null);
    const [singleOpenAssignTo, setSingleOpenAssignTo] = useState(false);
    const [singleAssignError, setSingleAssignError] = useState(false);
    const [assignItem, setAssignItem] = useState([]);
    const [assignToValue, setAssignToValue] = useState("");
    const [itemType, setItemType] = useState("");
    const [assignBtnDisable, setAssignBtnDisable] = useState(false);
    const [sendActivityType, setSendActivityType] = useState('');

    const [requestId,setRequestId]=useState("");
    const [mediatype,setMediaType]=useState("");
    const [approveMediaType, setApproveMediaType] = useState("");
    const [approveMediaStatus, setApproveMediaStatus] = useState("");
    const [folderName, setFolderName] = useState("");
    const [mediaServiceId,setMediaServiceId]=useState("");
    const [files, setFiles] = useState([]);
    const [open1, setOpen1] = React.useState(false);
    const [adminList, setAdminList] = React.useState([]);
    const handleClickOpen = () => {
        // console.log("companyDetails",companyDetails);
        // setCompanyDetails(companyDetailsData);
        setOpen(true);
    };

    const handleClickOpenAssignTo = (item,type) => {
        setAssignItem(item);
        setItemType(type);
        setAssignToValue(item.original.assigned_to != null ? item.original.assigned_to : '');
        setSingleOpenAssignTo(true);
        setSingleAssignError(false);
    };

    const handleCloseAssignTo = () => {
        setAssignBtnDisable(false);
        setAssignItem([]);
        setItemType("");
        setAssignToValue("");
        setSingleAssignError(false);
        setSingleOpenAssignTo(false);
    };

    const handleOpenViewFile = async(media_service_id,folderName,id,type,status) => {
        setFolderName(folderName);
        setMediaServiceId(media_service_id);
        setApproveMediaType(type);
        setRequestId(id);
        setApproveMediaStatus(status);
        handleFreezStart();
        const apiUrl = `/viewFile/${companyId}/${media_service_id}/${folderName}`;
        const res = await dispatch(fetchData(apiUrl )).unwrap();
        if (res) {
            if (res.success == true) {
                setFiles(res.data);
                handleFreezStop();
            } else {
                handleFreezStop();
            }
        } else {
            swal({
                title: "Failed",
                text: "Network Error",
                icon: "error",
                button: "Ok",
            });
        }
        setOpen1(true);
    };

    const handleCloseViewFile = () => {
        setOpen1(false);
    }

    const viewActivity = async(id,type) => {
        const apiUrl = '/getMediaServiceActivityLog/'+ id + '/' + type;
        const res = await dispatch(fetchData(apiUrl )).unwrap();
        if (res) {
            setActivityLog(res.data);
            setActivityType(type == "video" ? (res.data.media_service.service_name + " Video") : "Logo Design");
            setSendActivityType(type);
        }
        setActiveSection("activityLog");
    }

    const handleClose = (resetForm) => {
        resetForm();
        setOpen(false);
    };
    const fetchSalesAdminList = async () => {
    const apiUrl = '/fetchSalesAdmins'; // Replace with your API endpoint
    const res = await dispatch(fetchData(apiUrl)).unwrap();
    if (res) {
        setAdminList(res);
    }
    }
      
    useEffect(() => {
           getActivityLog();
           fetchSalesAdminList();
    }, []);
    
    useEffect(() => {
        if (Object.values(columnVisibility).length > 0) {
            setColumnVisibility(columnVisibility);
        }
        //do something when the row selection changes...
    }, [rowSelection]);
    
    useEffect(() => {
        tablePreferences();
    }, [rowSelection]);
    ////////////////////////
    
    useEffect(() => {
        if (Object.values(columnVisibility).length > 0) {
            http.post('/saveTablePreferences', {
                columnArray: columnVisibility,
                userId: user.id,
                tableId: 'mediaServiceActivityLog'
            }).then((result) => {
            })
        }
    }, [columnVisibility])

    const tablePreferencesArray = {
    }

    const tablePreferences = () => {
        http.get('/fetchTablePreferences/mediaServiceActivityLog')
            .then((res) => {
                if (Object.values(res.data).length == 0) {
                    setColumnVisibility(tablePreferencesArray);
                } else {
                    setColumnVisibility((JSON.parse(res.data.preferences)));
                }
            });
    }

    const csvOptions = {
        fieldSeparator: ',',
        quoteStrings: '"',
        decimalSeparator: '.',
        showLabels: true,
        useBom: true,
        useKeysAsHeaders: false,
        fileName: 'Activity Log of Media Services',
        headers: ['Service Requested','Assigned To','Assigned Date', 'Note','Status'],
    };
    
    const csvExporter = new ExportToCsv(csvOptions);
    const handleExportData = (data) => {
        var check = checkUserRole();
        if(check === true) {
            const exportedData = [];
            data.forEach((row) => {
            const mainTableRow = {
                serviceName: `${row.original.title}` || 'N/A',
                assignedTo: `${row.original.assigned_to}` || 'N/A',
                assignedDate: `${row.original.assigned_on?  Moment(row.original.assigned_on).format('MM-DD-YYYY') : 'N/A' }` || 'N/A',
                note: `${row.original.note}` || 'N/A',
                status: `${row.original.status}` || 'N/A',
            };
            exportedData.push(mainTableRow);
        });
        
        const csvContent = convertToCSV(exportedData);
        // Create a Blob object from the CSV data
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8' });
        
        // Create a download link element
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = csvOptions.fileName + '.csv';
        
        // Append the link to the document body
        document.body.appendChild(link);
        
        // Programmatically click the link to trigger the file download
        link.click();
        
        // Clean up the temporary URL and remove the link from the document
        URL.revokeObjectURL(link.href);
        link.remove();
        };
    }
    
    const convertToCSV = (data) => {
        const headers = csvOptions.headers.join(',') + '\n';
    
        const rows = data.map((row) => {
        return Object.values(row).map((value) => {
            // Handle any necessary formatting or escaping of values
            // For simplicity, we assume all values are already properly formatted
    
            // Wrap the value with double quotes if it contains a comma
            if (typeof value === 'string' && value.includes(',')) {
            return `"${value}"`;
            }
    
            return value;
        }).join(',');
        }).join('\n');
    
        return headers + rows;
        };

    const columns = useMemo(
        //column definitions...
        () => [
            {
                accessorFn: (data) => `${data}`,
                id: 'service_requested',
                header: 'Service Requested',
                size: 50,
                Cell: ({ renderedCellValue, row }) => (
                    row.original.title ? row.original.title: ''
                ),
            },
            {
                accessorFn: (data) => `${data}`,
                id: 'assigned_to',
                header: 'Assigned To',
                size: 50,
                Cell: ({ renderedCellValue, row }) => (
                        row.original.assigned_to ? 
                        row.original.assigned_to: 
                       <>
                       <AddCircleOutlineIcon fontSize="medium" onClick={() => handleClickOpenAssignTo(row,row.original.media_type)} sx={{ cursor: 'pointer' }} />
                       </>
                    ),
            },
            {
                accessorFn: (data) => `${ data.assigned_on ? Moment(data.assigned_on).format('MM-DD-YYYY') : 'N/A' } `,
                enableClickToCopy: true,
                id: 'assigned_on',
                header: 'Assigned Date',
                size: 150,
                Cell: ({ renderedCellValue, row }) => (
                    row.original.assigned_on?  Moment(row.original.assigned_on).format('MM-DD-YYYY'): 'N/A'
                ),
    
            },
            {
                accessorFn: (data) =>`${ data.note ? data.note : 'N/A' } `,
                id: 'note',
                header: 'Note',
                size: 50,
                Cell: ({ renderedCellValue, row }) => (
                    row.original.note ? row.original.note: 'N/A'
                ),
            },
            {
                accessorFn: (data) => `${data.status ? data.status : 'N/A'}`,
                id: 'Status',
                header: 'Status',
                size: 50,
                Cell: ({ renderedCellValue, row }) => (
                <Box display="flex" alignItems="center" justifyContent="center">
                    <Typography variant="body2">
                    {row.original.status ? row.original.status : 'N/A'}
                    </Typography>
                    {(row.original.status !== "Service Request Accepted" &&
                    row.original.status !== "Expert Assigned" &&
                    row.original.status !== "In Process") && (
                    <VisibilityOutlinedIcon
                        fontSize="small"
                        sx={{ cursor: "pointer", color: "black", marginLeft: 1 }}
                        onClick={() =>
                        handleOpenViewFile(
                            row.media_service_id,
                            row.status === "Completed" ? "approved_documents" : "pending_documents",
                            row.id,
                            row.media_type,
                            row.status
                        )
                        }
                    />
                    )}
                </Box>
                ),
            },
             {
                accessorFn: (data) => `${data}`,
                id: 'Actions',
                header: 'Actions',
                size: 50,
                Cell: ({ renderedCellValue, row }) => (
                    <div style={{display: 'flex',alignItems: 'center',cursor:"pointer"}} onClick={() => viewActivity(row.original.id,row.original.media_type)}>
                        <img src={require('../../../../assets/images/seeDetails.png')} style={{width:'10%'}}/> <span style={{marginLeft:"10px"}}>See Details</span>
                    </div>
                ),
            },
        ]
    );

    const checkUserRole = () => {
        const loginUser = JSON.parse(localStorage.getItem('user'));
        if(loginUser.roles_id != 1 && loginUser.roles_id != 2 && loginUser.roles_id != 15) {
            swal({
                title: "Failed",
                text: "This action is unauthorized.",
                icon: "error",
                button: "Ok",
            })
            navigate('/login');
            return false;
        }else{
            return true;
        }
    };
    const getActivityLog = async() => {
            handleFreezStart();
    
            const apiUrl = '/getMediaServiceDetails/'+companyId;
            const res = await dispatch(fetchData(apiUrl )).unwrap();
            if (res) {
                if (res.success == true) {
                    handleFreezStop();
                    // setData(res.data);
                    const apiData = res.data;
                    setAssetLink(res.data.assets_link);
                    const videos = apiData.video_config.map(item => ({
                        id: item.id,
                        media_service_id: item.media_service_id,
                        media_config_id: item.media_config_id,
                        media_type: "video",
                        // media_type_id: item.media_type_id,
                        assigned_to: item.assigned_to?item.sales_admin.name:"",
                        assigned_on: item.assigned_on,
                        status: item.status,
                        completed_on: item.completed_on,
                        title: item.media_service.service_name + " Video",
                        note: item.note,
                        // description: item.video_details.description,
                        created_at: item.created_at,
                        updated_at: item.updated_at
                      }));
    
                      const logo = apiData.logo_config
                      ? [{
                          id: apiData.logo_config.id,
                          media_service_id: apiData.logo_config.media_service_id,
                          media_type: "logo",
                        //   media_type_id: apiData.logo_config.media_type_id,
                          assigned_to: apiData.logo_config.assigned_to ? apiData.logo_config.sales_admin.name:"",
                          assigned_on: apiData.logo_config.assigned_on,
                          status: apiData.logo_config.status,
                          completed_on: apiData.logo_config.completed_on,
                          title: "Logo Design",
                          note: apiData.logo_config.note,
                        //   description: apiData.logo_config.logo_details.description,
                          created_at: apiData.logo_config.created_at,
                          updated_at: apiData.logo_config.updated_at
                        }]
                      : [];
    
                    const combinedMedia = [...videos, ...logo];
                    setData(combinedMedia);
                } else {
                    handleFreezStop();
                }
            } else {
                swal({
                    title: "Failed",
                    text: "Network Error",
                    icon: "error",
                    button: "Ok",
                });
            }
        }


    const activitySchema = Yup.object().shape({
        serviceId: Yup.string()
                .required('Please Select Service'),
        status: Yup.string()
                .required('Please Select Status'),
        note: Yup.string()
            .required('Please Add Note')
                .max(200, 'Note cannot be more than 200 characters'),

    });

    const handleSingleAssign =async () => {
        // Validation: Ensure at least one name is entered
        setAssignBtnDisable(true);
        if (assignToValue == "") {
            setSingleAssignError(true);
            return;
        }
        const apiUrl = '/assignedSingleMediaService';
        const args = {
            logId:assignItem.original.id,
            assignTo : assignToValue,
            type : itemType,
        };

        const res = await dispatch(postData({ apiUrl, args })).unwrap();
        if (res.success == true) {
            swal({
                title: "Success",
                text: res.message,
                icon: "success",
                button: "Ok",
            });
            handleCloseAssignTo(false);
            setAssignBtnDisable(false);
            getActivityLog();
        }else{
            swal({
                title: "Error",
                text: res.message,
                icon: "error",
                button: "Ok",
            })
            setAssignBtnDisable(false);
        }
    };

    return (
        <>
       { 
       activeSection === 'services'  ?
        <>
            <MaterialReactTable
                columns={columns}
                data={data}
                enableColumnFilterModes
                
                enableGrouping={false}
                enablePinning={false}
                enableRowSelection={false}
                onRowSelectionChange={setRowSelection} //connect internal row selection state to your own
                state={{ columnVisibility, rowSelection }} //pass our managed row selection state to the table to use
                initialState={{
                    showColumnFilters: false,
                    density: 'compact',
                }}
                onColumnVisibilityChange={(state) => { setColumnVisibility(state) }}
                positionToolbarAlertBanner="bottom"
                enableDensityToggle={false}
                muiTablePaperProps={{
                    sx: { backgroundColor: "white" },
                    }}
                    muiTableHeadCellProps={{
                        sx: {
                            backgroundColor: "#2A68B3",
                            color: "white",
                            fontWeight: "bold",
                            '& .MuiIconButton-root': {
                                color: 'white',
                                '&:hover': {
                                  color: 'white',
                                  backgroundColor: 'transparent', // avoid default hover bg
                                },
                                '&:focus': {
                                  color: 'white',
                                },
                                '&:active': {
                                  color: 'white',
                                },
                              },
                              '& .MuiSvgIcon-root': {
                                color: 'white',
                              },
                        },
                    }}
                //top csv option
                renderTopToolbarCustomActions={({ table }) => (
                    <Box
                        sx={{ display: 'flex', gap: '1rem', p: '0.5rem', flexWrap: 'wrap' }}
                    >
                        <Button
                        sx={{borderRadius:"10px",fontWeight:"bold",fontSize:"large",minWidth:isMobile?100:130,border:"1px solid #2A68B3"}}
                        disabled={table.getPrePaginationRowModel().rows.length === 0}
                        //export all rows, including from the next page, (still respects filtering and sorting)
                        onClick={() =>
                            handleExportData(table.getPrePaginationRowModel().rows)
                        }
                        //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
                        variant="outlined"
                        >
                        CSV
                        </Button>
                        {
                            user.roles_id == 1 || user.roles_id == 2 || user.roles_id == 15 ?
                            <Button
                            sx={{ bgColor: "#2A68B3" }}
                            disabled={table.getPrePaginationRowModel().rows.length === 0}
                            //export all rows, including from the next page, (still respects filtering and sorting)
                            onClick={() =>
                                handleClickOpen()
                            }
                            //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
                            variant="contained"
                            className='export'
                            >
                            New Activity
                        </Button>
                        : ''
                        }
                       
                    </Box>
                    )
                }
            />
        </>
        :
         <ActivityLog activityLog={activityLog} activityType={activityType} setActiveSection={setActiveSection} cid={companyId} assetLink={assetLink} type={sendActivityType} viewActivity={viewActivity} getActivityLog={getActivityLog}/>
        }

                <Formik
                    initialValues={{
                      serviceId: '',
                      status: '',
                      note: '',
                      inputMediaFile: '',
                    }}
                    validationSchema={activitySchema}
                    onSubmit={async(values,{ resetForm }) => { 
                        const apiUrl = '/addMediaServiceActivity';
                        if(values.status == "Pending For Review" && mediaType == "video" && values.inputMediaFile == '') {
                            setFileError("Please Upload Video");
                            return;
                        }else if(values.status == "Pending For Review" && mediaType == "logo" && values.inputMediaFile == '') {
                            setFileError("Please Upload Logo Image");
                            return;
                        }else if(values.status == "Pending For Review" && mediaType == "video" && values.inputMediaFile != '') {
                            const maxSizeInBytes = 150 * 1024 * 1024; 
                            if (values.inputMediaFile.size > maxSizeInBytes) {
                                setFileError("Video must not be larger than 150 MB.");
                                return;
                            }
                        }
                        setOpen(false);
                        handleFreezStart();
                        const formData = new FormData();
                        const [selectedId, selectedType] = values.serviceId.split('|');
                        formData.append('serviceId', selectedId);
                        formData.append('status', values.status);
                        formData.append('note', values.note);
                        formData.append('mediaType', mediaType);
                        formData.append('mediaFile',values.inputMediaFile);

                        const res = await dispatch(postFormData({apiUrl,formData})).unwrap();
                        if(res) {
                          
                            if(res.success === true){
                                swal({
                                    title: "Success",
                                    text: res.message,
                                    icon: "success",
                                    button: "Ok",
                                })
                              
                                getActivityLog();
                            }else{
                               
                                handleFreezStop();
                                swal({
                                    title: "Failed",
                                    text: res.message,
                                    icon: "error",
                                    button: "Ok",
                                })
                                if(res.message == "This action is unauthorized.") {
                                    navigate('/login');
                                }
                                
                            }
                            resetForm();
                        }
                    }}
                >
                    {({values,errors,touched,isSubmitting,handleChange,handleBlur,handleSubmit,setFieldValue,resetForm}) =>(
                        <Dialog
                            maxWidth={maxWidth}
                            fullWidth={fullWidth}
                            disableEscapeKeyDown={true}
                            open={open}
                            onClose={(_, reason) => {
                                if (reason !== "backdropClick") {
                                    handleClose(resetForm);
                                }
                            }}                           
                            aria-labelledby="responsive-dialog-title"
                            >
                            <DialogTitle textAlign={'center'} id="responsive-dialog-title" sx={{backgroundColor:"#F6FAFF"}}>
                                <Typography level="h4" color='primary'>New Activity</Typography>
                            </DialogTitle>
                            <Form>
                            <DialogContent>
                                <Box mt={1}>
                                <Grid container item lg={12} md={12} sm={12} xs={12}>                                                                      
                                        <Grid item lg={12} md={12} sm={12} xs={12}>
                                            <FormControl fullWidth size="small"
                                            error={touched.serviceId && errors.serviceId ? errors.serviceId : ''}
                                            >
                                                <InputLabel>Select Service *</InputLabel>
                                                <Select
                                                    labelId="demo-simple-select-label"
                                                    id="serviceId"
                                                    name="serviceId"
                                                    value={values.serviceId}
                                                    label="Select Service *"
                                                    onBlur={handleBlur('serviceId')}
                                                    onChange={(e)=>{
                                                        // handleCallType(e.target.value);
                                                        // const selectedId = e.target.value;
                                                        // const selectedService = data.find(service => service.id === selectedId);
                                                        // setMediaype(selectedService?.media_type);
                                                        // handleChange(e);
                                                        const [selectedId, selectedType] = e.target.value.split('|');
                                                        // setFieldValue("serviceId", selectedId);
                                                        setFieldValue("serviceId", e.target.value);
                                                        // const selectedService = data.find(service => String(service.id) === selectedId);
                                                        setMediaype(selectedType);
                                                    }}
                                                >
                                                    {data.map((service) => (
                                                    <MenuItem
                                                        value={`${service.id}|${service.media_type}`}
                                                    >
                                                        {service.title}
                                                    </MenuItem>
                                                ))}
                                                </Select>
                                                <FormHelperText>{touched.serviceId && errors.serviceId ? errors.serviceId : ''}</FormHelperText>
                                            </FormControl>
                                        </Grid>
                                        <Grid item lg={12} md={12} sm={12} xs={12} mt={1}>
                                            <FormControl fullWidth size="small"
                                            error={touched.status && errors.status ? errors.status : ''}
                                            >
                                                <InputLabel>Select Status *</InputLabel>
                                                <Select
                                                    labelId="demo-simple-select-label"
                                                    id="status"
                                                    name="status"
                                                    value={values.status}
                                                    label="Select Status *"
                                                    onBlur={handleBlur('status')}
                                                    onChange={(e)=>{
                                                        handleChange(e);
                                                    }}
                                                >
                                                    <MenuItem value="In Process">In Process</MenuItem>
                                                    <MenuItem value="Pending For Review">Pending For Review</MenuItem>
                                                    {/* <MenuItem value="Completed">Completed</MenuItem> */}
                                                </Select>
                                                <FormHelperText>{touched.status && errors.status ? errors.status : ''}</FormHelperText>
                                            </FormControl>
                                        </Grid>
                                        {
                                            values.status == "Pending For Review" && mediaType == "logo"?
                                            <>
                                                <FormControl variant="outlined" fullWidth margin="dense" size="small" 
                                                // error={touched.logo && Boolean(errors.logo)}
                                                >
                                                    <InputLabel htmlFor="uploadedLogoStep3">Upload your logo</InputLabel>
                                                        <OutlinedInput
                                                        id="uploadedLogoStep3"
                                                        type="text"
                                                        name="inputMediaFile"
                                                        sx={{ width: "60%" }}
                                                        value={values.inputMediaFile?.name || ""}
                                                        endAdornment={
                                                            <InputAdornment position="end">
                                                            <Tooltip title="Upload your logo">
                                                                <IconButton edge="end" onClick={() => fileInputRef.current?.click()}>
                                                                <img
                                                                    src={require("../../../../assets/images/uploadFile.png")}
                                                                    style={{ height: "25px" }}
                                                                    alt="Upload"
                                                                />
                                                                </IconButton>
                                                            </Tooltip>
                                                            </InputAdornment>
                                                        }
                                                        label="Upload your logo"
                                                        />
                                                            {fileError && (
                                                        <FormHelperText sx={{color:'red'}}>{fileError}</FormHelperText>)}
                                                        <input
                                                        ref={fileInputRef}
                                                        type="file"
                                                        name="inputMediaFile"
                                                        accept="image/png, image/jpeg, image/jpg"
                                                        onChange={(e) => {
                                                            const file = e.target.files[0];
                                                            e.target.value = null;
                                                            if (file) {
                                                                const allowedTypes = ["image/jpeg", "image/png", "image/jpg", "image/gif"];
                                                                if (!allowedTypes.includes(file.type)) {
                                                                    alert("Only JPEG, PNG, or GIF image files are allowed.");
                                                                    return;
                                                                }
                                                                const img = new Image();
                                                                img.onload = () => {
                                                                    if (img.width === 300 && img.height === 90) {
                                                                    setFieldValue("inputMediaFile", file);
                                                                    
                                                                    } else {
                                                                    alert("Logo must be exactly 300x90 pixels.");
                                                                    }
                                                                };
                                                                img.src = URL.createObjectURL(file);
                                                                console.log("values",values);
                                                            }
                                                        }}
                                                        style={{ display: "none" }}
                                                    />
                                                </FormControl>
                                            </> : ''
                                        }  
                                        {
                                            values.status == "Pending For Review" && mediaType == "video"?
                                            <>
                                               <FormControl variant="outlined" fullWidth margin="dense" size="small">
                                                    <InputLabel htmlFor="uploadedVideoStep3">Upload your video</InputLabel>
                                                        <OutlinedInput
                                                            id="uploadedVideoStep3"
                                                            type="text"
                                                            name="inputMediaFile"
                                                            sx={{ width: "60%" }}
                                                            value={values.inputMediaFile?.name || ""}
                                                            endAdornment={
                                                            <InputAdornment position="end">
                                                                <Tooltip title="Upload your video">
                                                                <IconButton edge="end" onClick={() => fileInputRef.current?.click()}>
                                                                    <img
                                                                    src={require("../../../../assets/images/uploadFile.png")}
                                                                    style={{ height: "25px" }}
                                                                    alt="Upload"
                                                                    />
                                                                </IconButton>
                                                                </Tooltip>
                                                            </InputAdornment>
                                                            }
                                                            label="Upload your video"
                                                        />
                                                        {fileError && (
                                                        <FormHelperText sx={{color:'red'}}>{fileError}</FormHelperText>)}
                                                        <input
                                                            ref={fileInputRef}
                                                            type="file"
                                                            name="inputMediaFile"
                                                            accept="video/mp4, video/webm" // Add more formats if needed
                                                            onChange={(e) => {
                                                            const file = e.target.files[0];
                                                            e.target.value = null;

                                                            if (file) {
                                                                const allowedTypes = ["video/mp4", "video/webm"];
                                                                const maxSizeMB = 150;
                                                                const maxSizeBytes = maxSizeMB * 1024 * 1024;

                                                                if (!allowedTypes.includes(file.type)) {
                                                                alert("Only MP4 or WebM video files are allowed.");
                                                                return;
                                                                }

                                                                if (file.size > maxSizeBytes) {
                                                                alert(`Video size must not exceed ${maxSizeMB} MB.`);
                                                                return;
                                                                }

                                                                // File is valid
                                                                setFieldValue("inputMediaFile", file);
                                                            }
                                                            }}
                                                            style={{ display: "none" }}
                                                        />
                                                    </FormControl>

                                            </> : ''
                                        }
                                        <Grid container item lg={12} md={12} sm={12} xs={12} mt={1} id="note">
                                            <Grid item lg={12} md={12} sm={12} xs={12}>
                                                <FormLabel>Note*</FormLabel>
                                                <FormControl fullWidth size="small"
                                                    error={touched.note && errors.note ? errors.note : ''}
                                                > 
                                                    <TextareaAutosize
                                                        aria-label="minimum height"
                                                        minRows={5}
                                                        placeholder="Note"
                                                        fullWidth
                                                        name="note"
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        value={values.note}
                                                    />
                                                    <FormHelperText>{touched.note && errors.note ? errors.note : ''}</FormHelperText>
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid> 
                                </Box>
                            </DialogContent>
                            <DialogActions>
                                <Grid container item lg={12} md={12} sm={12} xs={12} sx={{textAlign:"center",width:"100%"}}>
                                    <Grid item lg={6} md={6} sm={6} xs={6}>
                                        <Button  autoFocus variant="contained" sx={{minWidth:150}} 
                                        onClick={(e)=>{
                                            handleClose(resetForm);
                                        }}>
                                            CLOSE
                                        </Button>
                                    </Grid>
                                    <Grid item lg={6} md={6} sm={6} xs={6}>
                                        <Button variant="contained" sx={{minWidth:150}} color="success" type="submit" onClick={handleSubmit} disabled={ (isSubmitting) }>
                                            SAVE
                                        </Button>
                                    </Grid>
                                </Grid>
                            </DialogActions>
                            </Form>
                        </Dialog>

                    )}

                </Formik>

                 <Dialog
                        open={singleOpenAssignTo}
                        onClose={(event, reason) => {
                            if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
                                setSingleOpenAssignTo(false);
                                setAssignBtnDisable(false);
                            }
                        }}
                        fullWidth={fullWidth}
                        maxWidth={maxWidth}
                        PaperProps={{
                            sx: {
                                borderRadius: "12px",
                                padding: "20px"
                            }
                        }}
                    >
                        <DialogTitle className="dialog-title" >
                            <Typography variant="h6" fontWeight="bold"> Assign To </Typography>
                            <IconButton onClick={handleCloseAssignTo}>
                                <CloseIcon />
                            </IconButton>
                        </DialogTitle>
                        <DialogContent>
                        {assignItem && itemType?
                        <>
                            <Grid item xs={12} md={6} mt={1}>
                                <Grid container alignItems="center" spacing={2}>
                                    <Grid item xs={6}>
                                    <TextField
                                        fullWidth
                                        variant="outlined"
                                        size="small"
                                        value={itemType == "video" ? (assignItem.original.title ): 'Logo Design'}
                                    />
                                    </Grid>
                                    <Grid item xs={6}>
                                            <FormControl fullWidth margin='dense' size="small">
                                                <InputLabel id="demo-multiple-name-label">Assigned to</InputLabel>
                                                <Select
                                                id="assignedto"
                                                name="assignedto"
                                                input={<OutlinedInput label="Assigned To" />}
                                                // value={assignToValue}
                                                // onChange={handleSelectChange}
                                                onChange={(e) => {
                                                    setAssignToValue(e.target.value);
                                                    setAssignBtnDisable(false);
                                                    setSingleAssignError(false);
                                                }}
                                                MenuProps={MenuProps}
                                                size='small'
                                                >
                                                {adminList.map((array) => (
                                                    <MenuItem
                                                    key={array.id} // Ensure each MenuItem has a unique key
                                                    value={array.id}
                                                    >
                                                    {array.name}
                                                    </MenuItem>
                                                ))}
                                                </Select>
                                            </FormControl>
                                            <div style={{ color: 'red' }}>{singleAssignError ? "Please Enter Name" : ''}</div>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </>
                        :''
                        }
                        </DialogContent>
                        <DialogActions>
                            <Grid container item lg={12} md={12} sm={12} xs={12} sx={{ textAlign: "center", width: "100%" }} spacing={2} mt={1}>
                                <Grid item lg={6} md={6} sm={6} xs={6}>
                                    <Button variant="contained"  onClick={handleCloseAssignTo} className="cancel-button">
                                        Cancel
                                    </Button>
                                </Grid>
                                <Grid item lg={6} md={6} sm={6} xs={6}>
                                    <Button variant="contained"  className="save-button" onClick={handleSingleAssign} disabled={assignBtnDisable}>
                                        Assign
                                    </Button>
                                </Grid>
                            </Grid>
                        </DialogActions>
                    </Dialog>

                <Dialog
                    open={open1}
                    sx={{borderRadius:"10px"}}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    fullWidth={fullWidth}
                    maxWidth={maxWidth}
                >
                    <Card>
                    <CardOverflow
                        sx={{
                            bgcolor:'#2E67BC',
                            borderColor:'#2E67BC',
                            padding: '1%',
                        }}
                    >
                        <Grid item lg={12} md={12} sm={12} xs={12} display={"flex"} justifyContent={"right"}>
                                <Button onClick={handleCloseViewFile}><img src={require('../../../../assets/images/closeWhite.png')} /></Button>
                            </Grid>
                    </CardOverflow>
                    <CardContent sx={{height:"400px",overflowY:"scroll"}}> 
                          <Grid container spacing={2} mt={2}>
                            {files.length === 0 ? (
                            <Grid item xs={12}>
                                <Typography>No files found.</Typography>
                            </Grid>
                            ) : (
                            files.map((file) => {
                                const name = file.name.toLowerCase();
                                const isVideo = name.endsWith(".mp4");
                                const isImage = /\.(jpg|jpeg|png|gif)$/i.test(name);

                                return (
                                <Grid
                                    item
                                    key={file.id || file.path_lower}
                                    xs={12}
                                    sx={{ display: "flex", justifyContent: "center" }}
                                >
                                    {isVideo ? (
                                    <video
                                        width={isMobile ? "100%" : "250px"}
                                        controls
                                        src={file.temporary_link}
                                        style={{
                                        borderRadius: 4,
                                        marginTop: isMobile ? "1%" : "3%",
                                        }}
                                    >
                                        Your browser does not support the video tag.
                                    </video>
                                    ) : isImage ? (
                                    <img
                                        src={file.temporary_link}
                                        alt={file.name}
                                        style={{
                                        width: isMobile ? "100%" : "250px",
                                        height: "auto",
                                        borderRadius: 4,
                                        objectFit: "cover",
                                        }}
                                    />
                                    ) : null}
                                </Grid>
                                );
                            })
                            )}
                        </Grid>
                    </CardContent>
                    </Card>
                </Dialog>

        </>
    );
}
export default AvailedService;